import EmblaCarousel from "embla-carousel";
import { setupPrevNextBtns, disablePrevNextBtns } from '../helpers/carousel-buttons';

(() => {
	const filtersForm = document.querySelector(".m49__filters");
	if (!filtersForm) {
		return;
	}

	// If filter used, scroll to form.
	if (window.location.href.indexOf("filter-location") > -1) {
		document.getElementById("vacancies").scrollIntoView();
	}

	// Submit form when dropdowns are changed.
	const filters = document.querySelectorAll(".m49__filter");
	filters.forEach(filter => {
		filter.addEventListener("change", () => {
			filtersForm.submit();
		});
	});

	const slider = document.querySelectorAll(".m49");

	slider.forEach(carousel => {
		const viewport = carousel.querySelector(".m49__wrapper");
		const slides = viewport.querySelectorAll(".m49__slide");

		const isLessThanThree = slides.length < 3 && window.outerWidth >= 810;

		const options = {
			slidesToScroll: 1,
			align: "start",
			startIndex: 0,
			draggable: !isLessThanThree,
			containScroll: isLessThanThree ? "" : "trimSnaps",
		};

		const embla = EmblaCarousel(viewport, options);

		const prevBtn = carousel.querySelector(".m49__button--prev");
		const nextBtn = carousel.querySelector(".m49__button--next");
		const disablePrevAndNextBtns = disablePrevNextBtns(prevBtn, nextBtn, embla);

		setupPrevNextBtns(prevBtn, nextBtn, embla);

		const buttonUpdates = () => {
			if (!isLessThanThree) {
				prevBtn.classList.remove("hide-button");
				nextBtn.classList.remove("hide-button");
				disablePrevAndNextBtns();
			} else {
				prevBtn.classList.add("hide-button");
				nextBtn.classList.add("hide-button");
			}
		};

		embla.on("init", () => buttonUpdates());
		embla.on("select", () => buttonUpdates());
		embla.on("resize", () => buttonUpdates());

		if (isLessThanThree) {
			prevBtn.setAttribute("disabled", "disabled");
			nextBtn.setAttribute("disabled", "disabled");
		}
	});
})();
